module.exports = __webpack_public_path__ + "static/tools-of-titans-6a70c39de1f889afb1004d17a939d72d.jpg";